import { IndentValues } from "@/lib/utils/IndentValues";
import { SpaceValues } from "@/lib/utils/SpaceValues";
import {
  FeatureFlagsContext,
  FeatureFlagsContextType,
} from "@/config/featureFlags/FeatureFlagsContext";
import { Box, Space, Text } from "@stenajs-webui/core";
import React, { Fragment, useContext } from "react";
import { AuditData } from "../types/types";
import { transformAuditLogsToText } from "../lib/result-panel-transformers";

interface Props {
  auditData: AuditData[] | null;
}

export const PriceCalculatorAuditTab: React.FC<Props> = ({ auditData }) => {
  const { featureFlags } = useContext(
    FeatureFlagsContext
  ) as FeatureFlagsContextType;

  const auditDataError = () =>
    auditData && auditData.filter((ad) => ad.errorMessage) ? true : false;

  const auditErrorWithLogs = () => {
    if (auditDataError() && auditData) {
      return (
        <Box indent={IndentValues.TWENTYFOUR}>
          {auditData.map(
            (ad, index) =>
              ad.errorMessage && (
                <Fragment key={index}>
                  <Text variant={"bold"}>{`Error: ${ad.errorMessage}`}</Text>
                  <Space num={SpaceValues.FOUR} />
                </Fragment>
              )
          )}
          {auditData.some((ad) => ad.errorMessage) ? (
            <Space num={SpaceValues.SIXTEEN} />
          ) : null}
          {auditData?.map((leg, index) => (
            <Fragment key={index}>
              {transformAuditLogsToText(leg.auditLogs)}
              <Space num={SpaceValues.SIXTEEN} />
            </Fragment>
          ))}
        </Box>
      );
    }
  };

  return (
    <>
      {auditDataError()
        ? auditErrorWithLogs()
        : auditData?.map((leg, index) => (
            <Box indent={IndentValues.TWENTYFOUR} key={index}>
              {transformAuditLogsToText(leg.auditLogs)}
              <Space num={SpaceValues.SIXTEEN} />
            </Box>
          ))}
    </>
  );
};
